import {Component, forwardRef, Input} from '@angular/core';
import {NbFieldType, NbinputConfig, NbMassiveItem} from "./nbinput.entity";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'nbinput-viewer',
    template: require('./nbinput-viewer.component.html'),
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NbinputViewerComponent),
            multi: true
        }
    ]
})

export class NbinputViewerComponent {
    public FieldType = NbFieldType;

    private onTouchedCallback = () => {};
    private onChangeCallback = (_) => {};
    private onBlur = () => this.onTouchedCallback();
    registerOnChange(fn: any): void {if (fn) { this.onChangeCallback = fn; }}
    registerOnTouched(fn: any): void {if (fn) { this.onTouchedCallback = fn; }}
    setDisabledState?(isDisabled: boolean): void { }
    writeValue(obj: any ): void { this.data = obj; }

    @Input() data:string;
    @Input() options:NbMassiveItem[];
    @Input() type:NbFieldType = NbFieldType.Text;
    @Input() config: NbinputConfig = new NbinputConfig();
}

